import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/login',
      name: 'login',
      component: resolve => require(['../components/login.vue'], resolve)
    }, {
      path: '/search',
      name: 'search',
      component: resolve => require(['../components/search.vue'], resolve)
    }, {
      path: '/list',
      name: 'list',
      component: resolve => require(['../components/list.vue'], resolve)
    }, {
      path: '/map',
      name: 'map',
      component: resolve => require(['../components/map.vue'], resolve)
    }, {
      path: '/gui',
      name: 'gui',
      component: resolve => require(['../components/gui.vue'], resolve)
    }, {
      path: '/searchDetail',
      name: 'searchDetail',
      component: resolve => require(['../components/searchDetail.vue'], resolve)
    }, {
      path: '/detail',
      name: 'detail',
      component: resolve => require(['../components/detail.vue'], resolve)
    }, {
      path: '/about',
      name: 'about',
      component: resolve => require(['../components/about.vue'], resolve)
    }, {
      path: '/*',
      component: resolve => require(['../components/search.vue'], resolve)
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js